module.exports = __webpack_public_path__ + "static/img/bird_2.09139ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/bird_2.png
// module id = /p2h
// module chunks = 4